import type { FeedbackCheckResult, FeedbackDto, FeedbackSort, FeedbackStatus } from '@pb/shared';
import { asList, del, get, patch, post, query } from './client';

export interface FeedbackFilter {
  slideId?: number;
  groupId?: number;
  eventId?: number;
  statuses?: FeedbackStatus[];
  sort?: FeedbackSort;
}

export interface NewFeedback {
  slide_id?: number;
  group_id?: number;
  text: string;
  raised_by?: string;
  event_id?: number;
}

export const listFeedback = async (projectId: number, filter: FeedbackFilter) =>
  asList(
    await get<FeedbackDto[] | { items: FeedbackDto[] }>(
      `/projects/${projectId}/feedback${query({
        slide_id: filter.slideId,
        group_id: filter.groupId,
        event_id: filter.eventId,
        status: filter.statuses?.length ? filter.statuses.join(',') : undefined,
        sort: filter.sort,
      })}`,
    ),
  );
export const recordFeedback = (projectId: number, items: NewFeedback[]) =>
  post<FeedbackDto[]>(`/projects/${projectId}/feedback`, { items });
export const updateFeedback = (id: number, input: { text?: string; raised_by?: string }) =>
  patch<FeedbackDto>(`/feedback/${id}`, input);
export const setFeedbackStatus = (
  id: number,
  status: 'dismissed' | 'open' | 'awaiting_confirmation',
  answerVersionNo?: number,
) =>
  post<FeedbackDto>(`/feedback/${id}/status`, {
    status,
    ...(answerVersionNo === undefined ? {} : { answer_version_no: answerVersionNo }),
  });
export const recordFeedbackCheck = (id: number, result: FeedbackCheckResult) =>
  post<FeedbackDto>(`/feedback/${id}/check`, { result });
export const deleteFeedback = (id: number) => del<{ id: number; deleted: true }>(`/feedback/${id}`, { confirm: String(id) });
